import type React from "react";
import { useState } from "react";

import { Drawer, IconButton, Stack, styled as muiStyled } from "@mui/material";

import { BaseButton } from "shared/atoms/BaseButton";
import { CloseIcon } from "shared/icons";
import { useWindowSize } from "utils/hooks";

import type { PanelTabsProps } from "./PanelTabs";
import { PanelTabs } from "./PanelTabs";

const DRAWER_WIDTH = 425;

export const TreatmentEditorPanel: React.FC<PanelTabsProps> = ({
  children,
  formErrorSections,
  panelTab,
  setPanelTab,
}) => {
  const { isSmallScreen } = useWindowSize();
  const [isMobilePanelOpen, setIsMobilePanelOpen] = useState(false);

  return (
    <>
      {isSmallScreen && <BaseButton onClick={() => setIsMobilePanelOpen(true)} />}
      <StyledDrawer
        anchor="right"
        open={isMobilePanelOpen}
        variant="temporary"
        sx={{
          display: { xs: "block", sm: "none" },
          width: "100%",
        }}
        keepMounted
      >
        <Stack spacing={2}>
          <IconButton onClick={() => setIsMobilePanelOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
          <PanelTabs formErrorSections={formErrorSections} panelTab={panelTab} setPanelTab={setPanelTab} />
          {children}
        </Stack>
      </StyledDrawer>

      <StyledDrawer
        anchor="right"
        open
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          width: DRAWER_WIDTH,
        }}
      >
        <Stack sx={{ height: "100%", overflowY: "auto" }}>
          <PanelTabs formErrorSections={formErrorSections} panelTab={panelTab} setPanelTab={setPanelTab} />
          {children}
        </Stack>
      </StyledDrawer>
    </>
  );
};

const StyledDrawer = muiStyled(Drawer)(() => ({
  "& .MuiDrawer-paper": {
    boxSizing: "border-box",
    position: "relative",
    border: "none",
    borderRadius: "12px",
    height: "100%",
    zIndex: 1,
  },
}));
